import React from 'react';
import './loadingBar.css';

function LoadingBar() {
  return (
    <div className="loading-container">
      <div className="loading-track">
        {[...Array(10)].map((_, index) => (
          <div key={index} className="loading-item">
            <span className="spinner-border" aria-hidden="true"></span>
            <span className="loading-text">Loading...</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LoadingBar;
